import axios from 'axios'

export const cabinetAPI = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL
})

export const dtoolAPI = axios.create({
    baseURL: 'https://www.garagecabinets.com/dev/php'
})